import React from "react";
import Chart from "react-apexcharts";
import { HEATMAP_MONTHS } from "./dashboardUtils";

export const AdminHotelDailyRevenueSection = ({
  hotelRevenueLoading,
  hotelRevenueError,
  hotelRevenueSeries,
  hotelRevenueOptions,
  selectedHotelRevenueYear,
  selectedHotelRevenueMonth,
  yearList = [],
  onHotelRevenueYearChange,
  onHotelRevenueMonthChange,
  hotelRevenueTitle,
}) => {
  return (
    <div className="row g-3 mb-3">
      <div className="col-md-12">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h6 className="card-title mb-0">{hotelRevenueTitle}</h6>
            <div className="d-flex gap-2">
              <select
                className="form-select form-select-sm"
                value={selectedHotelRevenueYear}
                onChange={onHotelRevenueYearChange}
                style={{ width: "100px" }}
              >
                {yearList.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
              <select
                className="form-select form-select-sm"
                value={selectedHotelRevenueMonth}
                onChange={onHotelRevenueMonthChange}
                style={{ width: "120px" }}
              >
                {HEATMAP_MONTHS.map((month, index) => (
                  <option key={month} value={index + 1}>
                    {month}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="card-body">
            {hotelRevenueLoading ? (
              <p className="mb-0">Loading...</p>
            ) : hotelRevenueError ? (
              <p className="mb-0 text-muted">{hotelRevenueError}</p>
            ) : hotelRevenueSeries.length > 0 ? (
              <Chart
                options={hotelRevenueOptions}
                series={hotelRevenueSeries}
                type="heatmap"
                height={320}
              />
            ) : (
              <p className="mb-0 text-muted">No hotel daily revenue data available.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
